'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
    var style = props.style;

    return Object.assign({
        padding: context.muiTheme.baseTheme.spacing.desktopGutter / 2 + 'px ' + context.muiTheme.baseTheme.spacing.desktopGutter + 'px',
        background: context.muiTheme.baseTheme.palette.accent3Color,
        color: 'white',
        textTransform: 'uppercase'
    }, style);
}

/**
 * @desc
 * Default styles:
 * ```
 * {
 *   padding: `${context.muiTheme.baseTheme.spacing.desktopGutter / 2}px ${context.muiTheme.baseTheme.spacing.desktopGutter}px`
 *   background context.muiTheme.baseTheme.palette.accent3Color,
 *   color: 'white',
 *   textTransform: 'uppercase'
 * }
 * ```
 */

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: 'render',


        /**
         * @return {Node}
         */

        /**
         * @type {Object}
         * @property {Node} children child nodes
         * @property {string} className class
         * @property {Object} style styles
         */
        value: function render() {
            var styles = getStyles(this.props, this.context);
            return _react2.default.createElement(
                'div',
                { style: styles },
                this.props.children
            );
        }

        /**
         * @type {Object}
         * @property {Object} muiTheme theme
         */

    }]);

    return Label;
}(_react2.default.Component);

Label.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object
};
Label.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
};
exports.default = Label;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/Label.js
// module id = 1139
// module chunks = 0